<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 class="hidden-sm-and-down">Consultar Tocas</h2>
      <div class="flex-grow-1"></div>
    </v-card-title>
      <v-card flat>
        <v-card-text>
          <v-row
            justify="center"
          >
            <v-col cols="12" md="4">
              <v-text-field
                v-model="toca"
                label="Toca"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-text-field>
            </v-col>
            <v-col v-if="roleUser <= 1" rolecols="12" md="4">
              <v-select
                :items="salasList"
                v-model="sala"
                label="Sala"
                item-value="id"
                item-text="nombre"
                clearable
                v-on:keyup.enter="clickSearch()"
                >
              </v-select>
            </v-col>
          </v-row>

          <v-btn block color="primary" @click="clickSearch()" class="my-5">
            Buscar
          </v-btn>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-card>
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No se encontraron registros relacionados con la busqueda.</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
            </v-row>
          </v-alert>
        </div>

          <template>
            <v-card-title  style="color:#AF8936">
              <h5>{{ titleTabla }}</h5>
              <v-spacer></v-spacer>
              <h5>Total de tocas: {{this.total_tocas}}</h5>
            </v-card-title>
            <v-data-table
              :loading="loadingTable"
              hide-default-footer
              :headers="headers"
              :items="listTocas"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              hide-overlay
              show-expand
              item-key="id"
              disable-pagination
              class="elevation-1"
            >
              <template v-slot:item.action="{ item }">
                <div class="">
                <!-- <v-btn v-if="roleUser <= 1" class="mx-2" icon color="orange lighten-2" @click="editItem(item)">
                  <v-icon>mdi-account-edit</v-icon>
                </v-btn> -->
                <!-- <v-btn class="mx-2" dark x-small  color="blue lighten-1" style="margin-left: -6px;" @click="getPartesByToca(item)">VER PARTES
                </v-btn> -->
                <v-btn  v-if="item.count_confirmed_partes != 0 && (roleUser === 4 || roleUser === 5 || roleUser <=2)" class="mx-2" dark x-small  color="blue lighten-1" style="margin-left: -6px;" @click="notificarParte(item)">NOTIFICACIONES
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="item.pendientes.indexOf('Confirmar parte') > -1" class="mx-2" icon color="yellow darken-3" v-on="on">mdi-information</v-icon>
                  </template>
                  <span>Partes pendientes</span>
                </v-tooltip>
                <v-tooltip top v-if="item.pendientes.indexOf('Notificaciones sin abrir') > -1 ">
                  <template v-slot:activator="{ on }">
                    <v-icon class="mx-2" icon color="blue-grey darken-1" v-on="on">mdi-email</v-icon>
                  </template>
                  <span>Notificaciones sin Abrir</span>
                </v-tooltip>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-icon class="mx-2" icon color="blue-grey darken-1" v-on="on">mdi-email-open</v-icon>
                  </template>
                  <span>Notificaciones abiertas</span>
                </v-tooltip>
              </div>
              </template>

              <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
                <v-btn x-small color="blue lighten-1" dark @click="expand(true), getPartesByToca(item)" v-if="!isExpanded && (roleUser === 4 || roleUser <=2)">VER PARTES </v-btn>
                <v-btn x-small color="blue lighten-1" dark @click="expand(false)" v-if="isExpanded">Cerrar </v-btn>
              </template>

              <template v-slot:expanded-item="{headers, item}">
                <td :colspan="headers.length" style="padding: 0;">
                  <v-data-table
                    :headers="headers_partes"
                    :items="listPartes"
                    hide-default-footer
                    class="elevation-1"
                    :loading ="loadingTablePartes"
                  >
                  <template v-slot:item.pivot.acceso={item}>
                    <v-chip class="ma-2" small v-if="item.pivot.acceso == 1">Pendiente</v-chip>
                    <v-chip class="ma-2" small color="light-blue darken-4" dark v-if="item.pivot.acceso == 2"><b>Confirmado</b></v-chip>
                    <v-chip class="ma-2" small color="deep-orange darken-3" dark v-if="item.pivot.acceso == 3">Cancelado</v-chip>
                  </template>
                  <template v-slot:item.status="{ item }"  v-if="!isExpanded && (roleUser === 4 || roleUser <=2)">
                    <v-btn class="mx-2" x-small color="primary" dark v-if="item.pivot.acceso == 1 || item.pivot.acceso == 3" @click="confirmToca(item)">Confirmar</v-btn>
                    <v-btn class="mx-2" x-small color="deep-orange darken-3" dark v-if="item.pivot.acceso == 2" @click="cancelToca(item)" >Denegar</v-btn>
                  </template>
                  <template v-slot:item.cancelar="{ item }" v-if="!isExpanded && (roleUser === 4 || roleUser <=2)">
                    <v-btn class="mx-2" x-small color="deep-orange darken-3" dark v-if="item.pivot.acceso == 1" @click="cancelToca(item)" >Denegar</v-btn>
                  </template>
                  <template v-slot:item.nombre="{ item }" >
                    {{item.nombre}} {{item.primer_apellido}} {{item.segundo_apellido}}
                  </template>
                  <!-- <template v-slot:item.acuerdo="{ item }" >
                    <v-tooltip top v-if="item.pivot.acuerdo == 1 && item.pivot.acceso == 2">
                     <template v-slot:activator="{ on }">
                       <v-icon @click="acuerdoParte(item)" color="primary" dark v-on="on">mdi-file-alert-outline</v-icon>
                     </template>
                     <span>Enviar Acuerdo Pendiente</span>
                   </v-tooltip>
                  </template> -->
                  <template v-slot:item.eliminar="{ item }" >
                    <v-btn v-if="roleUser === 1" class="mx-2" x-small color="secondary" dark @click="deleteParteToca(item)">Eliminar</v-btn>
                  </template>
                  </v-data-table>
                </td>
              </template>

            </v-data-table>

            <!--<v-row justify="center" v-if="pagination.total>10">-->
            <v-row v-if="pagination.total >= 2 && listTocas.length" justify="center">
              <v-col cols="8">
                <v-pagination
                v-model="pagination.current"
                :length="pagination.total"
                :total-visible="7"
                @input="buscarToca"
                ></v-pagination>
              </v-col>
            </v-row>

          </template>

      </v-card>

    <br>
    <v-row justify="center" >
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card >
        <v-form>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Enviar Acuerdo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      <v-container>
        <h2>El Acuerdo se enviará a:</h2>
        <v-col cols="12" sm="6" v-for="data in to">
          <v-chip >
            {{ data.name}} ({{ data.email }})
          </v-chip>
        </v-col>
        <v-divider></v-divider>
        <v-col cols="10" md="8">
          <v-text-field
            v-model="addParte"
            label="Nombre de la Parte "
            required
          ></v-text-field>
          <v-btn small color="primary" dark @click="addPartes()">Agregar</v-btn>
        </v-col>
        <v-col cols="10" md="8">
          <ul>
            <li
              v-for="(parte,index) in notificacion.partes_generales"
              v-bind:key="parte"
              v-on:remove="notificacion.partes_generales.splice(index, 1)"
            >
            {{parte}}
            <v-btn x-small color="red darken-3" dark @click="removeParte(index)">X</v-btn>
          </li>
        </ul>
       </v-col>
     <v-divider></v-divider>
      <v-col cols="10" md="12">
        <v-text-field
          v-model="notificacion.asunto"
          label="Asunto"
          :rules="notBlankRules"
          required
        ></v-text-field>
      </v-col>
        <v-col cols="12" md="12">
        <v-card
            class="d-flex pa-2"
            outlined
            tile
            color="grey lighten-2">
            <div>Contenido</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <span class="title"></span>
          <vue-editor
            v-model="notificacion.contenido"
            outlined
            name="input-7-4"
            placeholder=""
            required
            :rules="notBlankRules"
          ></vue-editor>
        </v-col>
         <v-divider></v-divider>
         <br>
        <v-col cols="12" sm="12" md="12">
            <v-file-input
              v-model="file"
              color="blue darken-2"
              counter
              label="Adjuntar Archivo"
              multiple
              placeholder="Seleccione un archivo"
              prepend-icon="mdi-paperclip"
              outlined
              :rules="notBlankRules"
              @change="fileSelected()"
            >
            </v-file-input>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-btn block color="primary" dark @click="enviarNotificacion()">Enviar</v-btn>
        </v-col>
      </v-container>
      <v-overlay :value="overlay">
         <v-progress-circular indeterminate size="64"></v-progress-circular>
       </v-overlay>
    </v-form>
      </v-card>
    </v-dialog>
    </v-row>

    <v-overlay :value="overlay2">
       <v-progress-circular indeterminate size="64"></v-progress-circular>
     </v-overlay>

  </v-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');
  import { VueEditor } from "vue2-editor";
  export default {
    data: () => ({
      sala:'',
      toca: '',
      listPartes:[],
      salasList:[],
      expanded: [],
      expand:false,
      isExpanded:false,
      singleExpand:true,
      showTabla: false,
      showAlert: false,
      overlay:false,
      overlay2:false,
      partes_id:[],
      parte_id:'',
      pagination_data:[],
      pagination: {
        current: 1,
        total: 0
      },
      total_tocas:'',
      files:[],
      file:[],
      archivo:{
        encode:'',
        type:'',
        file_name:''
      },
      to:[],
      addParte: '',
      dialog: false,
      //search:'',
      //dialog: false,
      loadingTablePartes:false,
      loading:false,
      valid: true,
      titleTabla: 'ÚLTIMOS REGISTROS:',
      headers: [
        { text: 'Sala', value: 'sala', sortable: false, class: "title" },
        { text: 'Toca', value: 'identificador', sortable: false, class: "title" },
        { text: 'Acciones', value: 'data-table-expand', sortable: false, class: "title" },
        { text: '', value: 'action', sortable: false },
        // { text: '', value: 'data-table-expand', sortable: false },
      ],
      headers_partes: [
        { text: 'Nombre Completo', value:'nombre', sortable: false },
        { text: 'Estatus', value: 'pivot.acceso', sortable: false },
        { text: 'Acciones', value: 'status', sortable: false },
        { text: '', value: 'cancelar', sortable: false },
        { text: '', value: 'acuerdo', sortable: false },
        { text: '', value: 'eliminar', sortable: false }
      ],
      loadingTable: false,
      notificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      DefaultNotificacion:{
        partes_generales:[],
        asunto:'',
        contenido:'',
        file:''
      },
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }),
    computed: {
      ...mapGetters([
        "listTocas", "roleUser", "currentUser", "token_"
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Parte' : 'Editar Parte'
      },
    },
    mounted(){
      this.buscarToca();
      this.getSalas();
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BÚSQUEDA:'
        this.loadingTable = true
        this.buscarToca()
      },
      buscarToca() {
        this.overlay2 = true
        this.$store.dispatch("CONSULTAR_TOCAS", {
          toca: this.toca,
          sala: this.sala,
          current: this.pagination.current
        })
        .then((response) => {
          console.log(response);
          this.loadingTable = false;
          this.pagination.current = response.data.data.tocas.current_page;
          this.pagination.total = response.data.data.tocas.last_page;
          this.total_tocas = response.data.data.tocas.total;
          this.pagination_data = response.data.data.tocas;
          this.overlay2 = false;
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
            this.$store.commit("CONSULTAR_TOCAS", [])
          }
        })
        .catch(err => {
          this.loadingTable = false
          this.overlay2 = false
          //console.log(err);
          this.showAlert = true
          this.showTabla = false
          this.$store.commit("CONSULTAR_TOCAS", [])
        });
      },
      cancelToca(item) {
        Swal.fire({
          title: 'Denegar Parte?',
          // text: "Se Enviara Notificación!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#db522d',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Denegar!',
          cancelButtonColor: '#bdbdbd'
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("CANCEL_TOCA", {
              parte_id: item.pivot.parte_id,
              toca_id: item.pivot.toca_id,
            })
            .then((response) => {
              if (response.data) {
                Swal.fire({
                  icon: 'success',
                  title: 'Denegada!',
                  showConfirmButton: false,
                  timer: 1500
                })
                this.buscarToca();
                this.updatePartesByToca(item.pivot);
              }
            })
            .catch(err => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: 'Error al enviar Notificación!',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarToca();
              this.updatePartesByToca(item.pivot);
            });
          }
        })
      },
      confirmToca(item) {
        Swal.fire({
          title: 'Confirmar Parte?',
          // text: "Se Enviara Notificación de Confirmación!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#66bb69',
          cancelButtonColor: '#bdbdbd',
          confirmButtonText: 'Confirmar!',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.value) {
            //console.log(item);
            this.$store.dispatch("CONFIRM_TOCA", {
              parte_id: item.pivot.parte_id,
              toca_id: item.pivot.toca_id,
            })
            .then((response) => {
              if (response.data) {
                Swal.fire({
                  icon: 'success',
                  title: 'Confirmada!',
                  showConfirmButton: false,
                  timer: 1500
                })
                this.buscarToca();
                this.updatePartesByToca(item.pivot);
                this.acuerdoParte(item);
              }
            })
            .catch(err => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: 'Error al confirmar!',
                showConfirmButton: false,
                timer: 1500
              })
              this.buscarToca();
              this.updatePartesByToca(item.pivot);
            });
          }
        })
      },
      getSalas() {
        this.$store
          .dispatch("GET_SALAS")
          .then((response) => {
            this.salasList = response.data.salas;//usar response para datos, se puede usar getters
            //console.log(response);
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      getPartesByToca(item) {
        this.loadingTablePartes = true
        this.$store
          .dispatch("GET_PARTES_TOCA", {
            toca_id: item.id,
          })
          .then((response) => {
            this.loadingTablePartes = false
            //console.log("el response de las no validadas",response.data.data.partes);
            Object.entries(response.data.data.partes).forEach(([key, laparte]) => {
              if(laparte.validada == 2){
                laparte.nombre = '( NV ) ' + laparte.nombre
              }
            });

            this.listPartes = response.data.data.partes;
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      updatePartesByToca(item) {
        this.$store
          .dispatch("GET_PARTES_TOCA", {
            toca_id: item.toca_id,
          })
          .then((response) => {
            //console.log(response.data.data);
            this.listPartes = response.data.data.partes;
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      notificarParte(item){
        this.$router.push('/notificaciones/' + item.id)
      },
      acuerdoParte(item){
        var email = item.email
        var name = item.nombre+' '+item.primer_apellido+' '+item.segundo_apellido
        this.to.push({ email: email, name: name } )
        var parte_id = ''+item.pivot.parte_id
        this.partes_id.push(parte_id)
        this.toca_id = item.pivot.toca_id
        this.parte_id = item.pivot.parte_id
        this.dialog = true
      },
      enviarNotificacion() {
        if(this.file==""| this.notificacion.asunto==""  || this.notificacion.contenido=="" || this.notificacion.partes_generales==""){
          Swal.fire({
            icon: 'warning',
            title: 'Todos los Campos son obligatorios',
            showConfirmButton: false,
            timer: 2000
          })
        } else {
          this.FilesToUpload();
          this.overlay = true
          this.$store.dispatch("ENVIA_NOTIFICACION", {
            partes_id: this.partes_id,
            toca_id: this.toca_id,
            subject: this.notificacion.asunto,
            content: this.notificacion.contenido,
            partes_generales: this.notificacion.partes_generales,
            file:this.archivo
          })
          .then((response) => {
            if (response.data.status == 'ok') {
              console.log(response);
                Swal.fire({
                  icon: 'success',
                  title: 'Notificación Enviada',
                  showConfirmButton: false,
                  timer: 1500
                })
              this.confirmAcuerdo();
            }
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se envió la notificación',
              showConfirmButton: false,
              timer: 1500
            })
            this.overlay = false
          });
         }
      },
      confirmAcuerdo() {
        this.$store
          .dispatch("CONFIRM_ACUERDO", {
            toca_id: this.toca_id,
            parte_id:this.parte_id
          })
          .then((response) => {
          //console.log(response);
          if (response.data.status == 'ok') {
            var toca = response.data.data.toca
            this.close();
            this.getPartesByToca(toca);
            }
          })
          .catch(err => {
            console.log(err);
            //this.showAlert(this.notification);
          });
      },
      fileSelected(){
        var file = this.file[0];
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['file_name'] = this.file[0].name
          });
        }
      },
      close () {
        setTimeout(() => {
          this.notificacion = Object.assign({}, this.DefaultNotificacion)
          this.dialog = false
          this.overlay = false
          this.to = []
          this.file = []
          this.notificacion.partes_generales = []
          this.partes_id = []
          this.parte_id =''
          this.toca_id=''
        }, 300)

      },
      addPartes() {
        if (this.addParte=="") {
          Swal.fire({
            icon: 'warning',
            title: 'El campo esta vacío',
            showConfirmButton: false,
            timer: 1500
          })
        }else{
          this.notificacion.partes_generales.push(this.addParte)
          this.addParte = ''
        }
    },
    removeParte(index) {
      this.notificacion.partes_generales.splice(index, 1)
    },

    deleteParteToca(item) {
      this.loadingTablePartes = true
      this.overlay2 = true
      this.$store
        .dispatch("DELETE_PARTE_TOCA", {
          toca_id: item.pivot.toca_id,
          parte_id:item.pivot.parte_id
        })
        .then((response) => {
          this.loadingTablePartes = false
          this.overlay2 = false
          //console.log(response);
        if (response.data.status == 'ok') {
          if(response.data.data.toca){
            Swal.fire({
              icon: 'success',
              title: 'Se Elimino Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
            var toca = response.data.data.toca
            this.getPartesByToca(toca);
          } else {
            this.buscarToca();
          }
        }
        })
        .catch(err => {
          this.loadingTablePartes = false
          this.overlay2 = false
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response.data,
            showConfirmButton: false,
            timer: 1500
          })
        });
      },

  }
};
</script>
